import React from "react";
import { observer } from "mobx-react";

const FeedbackContext = React.createContext();

export default observer(function FeedbackProvider({ children }) {
  const [popup, setPopup] = React.useState(false);
  const [success, setSuccess] = React.useState(false);

  const openFeedback = () => {
    setSuccess(false);
    setPopup(true);
  };

  const closeFeedback = () => {
    setPopup(false);
    setSuccess(false);
  };

  return (
    <FeedbackContext.Provider
      value={{ popup, success, openFeedback, closeFeedback, setSuccess }}
    >
      {children}
    </FeedbackContext.Provider>
  );
});

export function useFeedbackContext() {
  return React.useContext(FeedbackContext);
}
